
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import React, { useState } from "react";
import axios from "axios";

export default function DepartmentMaster() {
  const [formData, setFormData] = useState({
    code: "DP101314",
    departmentName: "",
    longDescription: "",
    note1: "",
    note2: "",
    note3: "",
    date1: "",
    date2: "",
    createdDate: new Date().toLocaleString(),
    addedBy: "1",
    status: "Active",
    location: "",
    company: "",
    uploadImage: null,
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("http://localhost:5000/api/department", formData);
      alert("✅ Department saved successfully! ID: " + response.data.id);
    } catch (error) {
      console.error("❌ Error saving department:", error);
      alert("Failed to save department");
    }
  };


  return (
     <DashboardLayout>
          <DashboardNavbar />
    <div className="p-6 bg-white shadow-md rounded-lg text-sm">
      {/* Header */}
      <div className="flex justify-between items-center border-b pb-3 mb-5">
        <h2 className="text-base font-semibold flex items-center">
         Add Employee Department
        </h2>
        <button className="px-3 py-1.5 bg-gray-200 text-sm rounded-md hover:bg-gray-300 transition">
          Back
        </button>
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit} className="grid grid-cols-3 gap-5">
        {/* Left Column */}
        <div className="space-y-3">
          <div>
            <label className="block text-gray-700">Code</label>
            <input
              type="text"
              name="code"
              value={formData.code}
              readOnly
              className="mt-1 block w-full border rounded-md p-2 bg-gray-100 text-sm"
            />
          </div>

          <div>
            <label className="block text-gray-700">Note 1</label>
            <input
              type="text"
              name="note1"
              value={formData.note1}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700">Date 1</label>
            <input
              type="date"
              name="date1"
              value={formData.date1}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700">Created Date</label>
            <input
              type="text"
              name="createdDate"
              value={formData.createdDate}
              readOnly
              className="mt-1 block w-full border rounded-md p-2 bg-gray-100 text-sm"
            />
          </div>

          <div>
            <label className="block text-gray-700">Location</label>
            <select
              name="location"
              value={formData.location}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            >
              <option value="">Select Location</option>
              <option value="Delhi">Delhi</option>
              <option value="Mumbai">Mumbai</option>
              <option value="Bangalore">Bangalore</option>
            </select>
          </div>
        </div>

        {/* Middle Column */}
        <div className="space-y-3">
          <div>
            <label className="block text-gray-700">Department Name</label>
            <input
              type="text"
              name="departmentName"
              value={formData.departmentName}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700">Note 2</label>
            <input
              type="text"
              name="note2"
              value={formData.note2}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700">Date 2</label>
            <input
              type="date"
              name="date2"
              value={formData.date2}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700">Status</label>
            <select
              name="status"
              value={formData.status}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>

          <div>
            <label className="block text-gray-700">Upload Image</label>
            <input
              type="file"
              name="uploadImage"
              onChange={handleChange}
              className="mt-1 block w-full text-sm"
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-3">
          <div>
            <label className="block text-gray-700">Long Description</label>
            <input
              type="text"
              name="longDescription"
              value={formData.longDescription}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700">Note 3</label>
            <input
              type="text"
              name="note3"
              value={formData.note3}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            />
          </div>

          <div>
            <label className="block text-gray-700">Added By</label>
            <input
              type="text"
              name="addedBy"
              value={formData.addedBy}
              readOnly
              className="mt-1 block w-full border rounded-md p-2 bg-gray-100 text-sm"
            />
          </div>

          <div>
            <label className="block text-gray-700">Company</label>
            <select
              name="company"
              value={formData.company}
              onChange={handleChange}
              className="mt-1 block w-full border rounded-md p-2 text-sm focus:ring focus:ring-blue-200"
            >
              <option value="">Select Company</option>
              <option value="TCS">TCS</option>
              <option value="Infosys">Infosys</option>
              <option value="Wipro">Wipro</option>
            </select>
          </div>
        </div>
      </form>

      {/* Buttons */}
      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="submit"
          onClick={handleSubmit}
          className="px-4 py-2 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition"
        >
          Save
        </button>
        <button
          type="button"
          className="px-4 py-2 bg-gray-600 text-white text-sm rounded-md hover:bg-gray-700 transition"
        >
          Cancel
        </button>
      </div>
    </div>
     </DashboardLayout>
          
  );
}
